/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */

import { combineReducers } from 'redux';

import { IAuthState } from '../types/authTypes';
import { IChangePasswordState } from '../types/changePasswordTypes';
import { IRecoveryState } from '../types/recoveryTypes';
import authCacheReducer, { IAuthCacheState } from './authCacheReducer';
import authReducer from './authReducer';
import changePasswordReducer from './changePasswordReducer';
import recoveryReducer from './recoveryReducer';

export interface IRootAuthReducer {
    authData: IAuthState;
    cache: IAuthCacheState;
    changePassword: IChangePasswordState;
    recovery: IRecoveryState;
}

export const rootAuthReducer = () => combineReducers<IRootAuthReducer>({
    authData: authReducer,
    cache: authCacheReducer,
    changePassword: changePasswordReducer,
    recovery: recoveryReducer,
});
